<template>
  <div class="container">
    <!-- <transition :css="false"> -->
    <el-dialog title="" :visible.sync="modalSucess" width="40%">
      <div class="heading">
        <h2 class="login-title text-success">Payment Successful</h2>
      </div>
     <div  class="text-center">
      <p>
        Your payment was made successfully, In due time , one of our agents would contact with you shortly for the intallation, distribution and guide process.
      </p>
         <a href="https://arnergy.com/" class="text-center">
                <button size="md" class="btn btn-md btn-info">
                  Okay
                </button>
              </a>
              </div>
    </el-dialog>
    <!-- </transition> -->
   
     <modal-verify
      v-if="modalVerify"
      @close="showModalValidated = false"
    ></modal-verify>

  
       <modal-sucess
        v-if="modalSucess"
        @close="modalSucess = false"
        :message="messageSuccess"
      ></modal-sucess>
    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
      <!-- {{packageConfigs}} -->
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <h3>Payment</h3>
        <hr />
      </div>
    </vk-offcanvas>
    <div class="col-xl-12 col-lg-5 col-md-5 offset-4">
      <div
        class="page-content__header-description"
        style="display: flex; margin-bottom: 20px;"
      >
        <h2 style="flex: 1;">Payment Process</h2>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12">
          <div class="container-fluid">
            <div class="heading">
              <h2 class="login-title">Payment Feeback Page</h2>
            </div>
            <form>
              <arnergy-input label="First name" :model="firstName" disabled />
              <arnergy-input :model="lastName" label="Last name" disabled />
              <arnergy-input label="Email" :model="email" disabled />
              <label class="text-dark">Amount</label>
            </form>
            <div class="paying-now">
              <span>Paying now</span>
              <span>
                NGN{{ (productAmt + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
              </span>
            </div>

            <!-- real footer item -->
            <button @click="flutterwavePay" class="submit-button" type="button">
              Make Payment
            </button>
            <div class="footer-lock">
              <i class="fa fa-lock"></i>
              <small class="small">
                Payment are encrypted using 256-bit SSL
              </small>
            </div>
            <p class="space small">
              By clicking
              <span>"Make Payment"</span>
              you acknowledge that you have read and agree to our
              <a class="link" href="#">Terms of Use</a>
              and
              <a class="link" href="#">Privacy Policy</a>
              ; you will e charged the same price every 12months untill you
              cancel your membership or complete payment. You may cancel
              subscription by accessing Account settings section on your
              dashboard.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from '../users/index'
import Devices from '../devices/List'
import transactionHistories from '../shs/Wallet'
import Rave from "vue-ravepayment";
import ArnergyInput from '../kitchen/ArnergyInput'
import userRole from '../users/allow'
import ModalVerify from "../kitchen/Onboarding/modal-verify.vue";
import ModalSuccess from "../kitchen/Onboarding/ModalSuccess.vue";
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Dialog,
  RadioButton,
  // ...
} from 'element-ui'
import router from '../../../router';
import { Offcanvas, OffcanvasClose } from 'vuikit/lib/offcanvas'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: '',
  components: {
    'vk-offcanvas': Offcanvas,
    'vk-offcanvas-close': OffcanvasClose,
    'el-autocomplete': Autocomplete,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-dialog': Dialog,
    'el-radio': Radio,
    ModalVerify,
    ModalSuccess,
    'el-radio-group': RadioGroup,
    'el-radio-button': RadioButton,
    Users,
    ArnergyInput,
    Devices,
    transactionHistories,
    userRole,
  },
  data() {
    return {
      showOffCanvas: false,
      activeTab: 'user_list',
      usertype: localStorage.roleType,
      showModal: true,
      firstName: 'Victor',
      lastName: 'Abimbola',
      email: 'abimbolavitor3@gmail.com',
      modalVerify: false,
      modalSucess:false,
      messageSuccess: "",
      productAmt: "",
      phone_number: "",
    }
  },
  computed: { 
    ...mapGetters(['getOsCustomer']),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    },
  },
  methods: {
    ...mapActions(['saveOsCustomer']),
    flutterwavePay() {
      FlutterwaveCheckout({
        // public_key: 'FLWPUBK_TEST-SANDBOXDEMOKEY-X',
        public_key: 'FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X',
        tx_ref: this.genRandomNumber,
        amount: this.productAmt,
        currency: 'NGN',
        country: 'NG',
        paymentType: 'account',
        // paymentOptions: 'ussd',
        
        // specified redirect URL
        // redirect_url: 'https://solarbase.arnergy.com/auth/paymentFeedback',
        redirect_url: 'https://solarbase.arnergy.com/auth/login',
        meta: {
          consumer_id: 23,
          consumer_mac: '92a3-912ba-1192a',
        },
        customer: {
          email: this.email,
          phone_number: this.phone_number,
          name: `${this.firstName} ${this.lastName}`,
        },
        callback: function (data) {
          console.log(data)
        },
        onclose: function () {
          // close modal
        },
        customizations: {
          title: 'Arnergy Solar',
          description: 'Payment',
          logo: 'https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg',
        },
      })
    },
         async verify(tx_ref) {
      const data = {
        txref: tx_ref,
        lastName: localStorage.lastName,
        firstName: localStorage.firstName,
        customerId: parseInt(localStorage.customerId),
      };

      if (data.txref) {
        console.log(data);
        this.$emit("showLoading", true);
        const HTTP = this.$httpUtils.instance;

        try {
          let res = await HTTP.post("/payments/verifyPayment", data);
          this.$emit("showLoading", false);

          if (res.data.customerid) {
            this.modalSucess = true;
            this.messageSuccess = res.data.message
            return;
          }

          if (res.data == null || res.status == 204) {
            this.modalVerify = true;
            return;
          }
        } catch (error) {
          this.modalVerify = true;
        
          console.log("working 50  modal suppose show");
          console.log(error);
          this.$emit("showLoading", false);
          this.showErrorMsg({
            message: "Unable to complete action, please try again.",
          });
        }
      }
    },

  },
  created() {
    const customer = this.getOsCustomer || localStorage.getItem('osCustomer');
    if (!this.getOsCustomer) this.saveOsCustomer(localStorage.getItem('osCustomer'));
    this.firstName = customer.firstName
    this.lastName = customer.lastName
    this.email = customer.email
    this.productAmt = customer.productAmt
    this.phone_number = customer.phone_number
  },
  // mounted() {
  //   const url = window.location.href;
  //   var res = url.slice(36);
  //   var DATA = res.split("&");
  //   const txref = DATA[1].slice(7)
  //   this.verify(txref)
  // },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_reduced_variables.scss';
.parent-box {
  position: relative;
}

.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}

.link {
  color: $primary-color;
  font-weight: bold;
}

.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.space {
  margin: 20px 0;
  margin-left: 20px;
  color: #8f8d8c;

  span {
    color: black;
    font-weight: bold;
  }
}

.misbehave {
  margin: 50px auto 20px auto;
  max-width: 550px;
}

.checkbox-style {
  display: flex;
  // align-items: center;

  input,
  p {
    margin-right: 5px;
  }

  p {
    margin: 0;
  }
}

.packages {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  div {
    margin: 10px;
  }
}

.footer {
  margin: 50px auto;
  max-width: 550px;
}

.flex {
  display: flex;
  align-items: center;

  > :first-child {
    margin-right: 5px;
  }
}

.intro-title {
  text-align: center;
  position: relative;

  .text {
    font-weight: bold;
    position: relative;
    z-index: 10;
    display: inline;
    background: #f9f9f9;
    padding: 0 20px;
  }

  &:before {
    width: 100%;
    height: 2px;
    background: #ebebeb;
    display: block;
    content: '';
    position: absolute;
    top: 10px;
    z-index: 0;
    // bottom: 0;
  }
}

.paying-now {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ebebeb;
  padding: 10px 0;
  font-size: 24px;

  span {
    color: black;
    font-weight: bold;
  }

  span:first-child {
    font-size: 12px;
    margin-right: 10px;
  }
}

.footer-lock {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;

  .small {
    font-weight: bold;
    margin-left: 5px;
    color: black;
  }
}

.submit-gif {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  color: white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
}

.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/payment/Feedback.vue